import { render, staticRenderFns } from "./ShutterImpacts.vue?vue&type=template&id=0fa9c180&scoped=true"
import script from "./ShutterImpacts.vue?vue&type=script&lang=ts"
export * from "./ShutterImpacts.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fa9c180",
  null
  
)

export default component.exports